export default "__VITE_ASSET__CCr48AbS__"